import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
const ariaLabelPrevPage = __('Previous page');
const ariaLabelNextPage = __('Next page');
export const PaginationPrevNext = ({ hasNextPage, hasPreviousPage, onPageChange, }) => {
    const handlePrevious = useCallback(() => {
        onPageChange('prev');
    }, [onPageChange]);
    const handleNext = useCallback(() => {
        onPageChange('next');
    }, [onPageChange]);
    return (_jsxs(Box, { "data-testid": "pagination-prev-next", flexWrap: "wrap", justifyContent: "center", children: [_jsx(Button, { "aria-label": ariaLabelPrevPage, dataTestId: "pagination-prev", icon: () => (_jsx(FontAwesomeIcon, { height: "14px", iconName: "angle-left", iconType: CATEGORIES.SOLID })), isDisabled: !hasPreviousPage, onClick: handlePrevious, size: "small", variant: "inversed" }), _jsx(Button, { "aria-label": ariaLabelNextPage, dataTestId: "pagination-next", icon: () => (_jsx(FontAwesomeIcon, { height: "14px", iconName: "angle-right", iconType: CATEGORIES.SOLID })), isDisabled: !hasNextPage, ml: 2, onClick: handleNext, size: "small", variant: "inversed" })] }));
};
//# sourceMappingURL=PaginationPrevNext.js.map